export class NativeStreamAggregationConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "tableName",
            "baseName": "tableName",
            "type": "string",
            "format": ""
        },
        {
            "name": "namespace",
            "baseName": "namespace",
            "type": "string",
            "format": ""
        },
        {
            "name": "eventTime",
            "baseName": "eventTime",
            "type": "string",
            "format": ""
        },
        {
            "name": "groupBy",
            "baseName": "groupBy",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "metrics",
            "baseName": "metrics",
            "type": "Array<NativeStreamAggregationMetric>",
            "format": ""
        },
        {
            "name": "paneMinutes",
            "baseName": "paneMinutes",
            "type": "number",
            "format": ""
        },
        {
            "name": "retentionMinutes",
            "baseName": "retentionMinutes",
            "type": "number",
            "format": ""
        },
        {
            "name": "refreshSeconds",
            "baseName": "refreshSeconds",
            "type": "number",
            "format": ""
        },
        {
            "name": "partitionBuckets",
            "baseName": "partitionBuckets",
            "type": "number",
            "format": ""
        },
        {
            "name": "shards",
            "baseName": "shards",
            "type": "number",
            "format": ""
        },
        {
            "name": "placement",
            "baseName": "placement",
            "type": "NativeStreamAggregationPlacement",
            "format": ""
        },
        {
            "name": "inputFilter",
            "baseName": "inputFilter",
            "type": "string",
            "format": ""
        },
        {
            "name": "outputFilter",
            "baseName": "outputFilter",
            "type": "string",
            "format": ""
        },
        {
            "name": "derived",
            "baseName": "derived",
            "type": "Array<NativeStreamAggregationDerivedColumn>",
            "format": ""
        },
        {
            "name": "entry",
            "baseName": "entry",
            "type": "NativeStreamAggregationEntryRule",
            "format": ""
        },
        {
            "name": "serving",
            "baseName": "serving",
            "type": "NativeStreamAggregationServing",
            "format": ""
        },
        {
            "name": "spans",
            "baseName": "spans",
            "type": "NativeStreamAggregationSpans",
            "format": ""
        },
        {
            "name": "outputId",
            "baseName": "outputId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "tableLocation",
            "baseName": "tableLocation",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamAggregationConfig.attributeTypeMap;
    }
    constructor() {
    }
}
